var map = {
	"./AU.svg": 928,
	"./CH.svg": 929,
	"./DE.svg": 930,
	"./FI.svg": 931,
	"./FR.svg": 932,
	"./GB.svg": 933,
	"./IE.svg": 934,
	"./JP.svg": 935,
	"./LU.svg": 936,
	"./NL.svg": 937,
	"./NO.svg": 938,
	"./SE.svg": 939,
	"./US.svg": 940,
	"./ZA.svg": 941
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1191;


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/countries ^\.\/.*\.svg$
// module id = 1191
// module chunks = 0